import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from '../baseTypes';
import { getAppointmentReminders } from '@uplift/api';


export const useAppointmentRemindersQuery = (appointmentId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'appointment', appointmentId, 'reminders' ], async () => {
    const response = await getAppointmentReminders(appointmentId);

    return response.data;
  }, opts);
};
